"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Commander Spellbook API
 * API for Commander Spellbook, the combo database engine for Magic: The Gathering
 *
 * The version of the OpenAPI document: 4.8.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfPaginatedTemplateList = instanceOfPaginatedTemplateList;
exports.PaginatedTemplateListFromJSON = PaginatedTemplateListFromJSON;
exports.PaginatedTemplateListFromJSONTyped = PaginatedTemplateListFromJSONTyped;
exports.PaginatedTemplateListToJSON = PaginatedTemplateListToJSON;
exports.PaginatedTemplateListToJSONTyped = PaginatedTemplateListToJSONTyped;
const template_1 = require("./template");
/**
 * Check if a given object implements the PaginatedTemplateList interface.
 */
function instanceOfPaginatedTemplateList(value) {
    if (!('count' in value) || value['count'] === undefined)
        return false;
    if (!('next' in value) || value['next'] === undefined)
        return false;
    if (!('previous' in value) || value['previous'] === undefined)
        return false;
    if (!('results' in value) || value['results'] === undefined)
        return false;
    return true;
}
function PaginatedTemplateListFromJSON(json) {
    return PaginatedTemplateListFromJSONTyped(json, false);
}
function PaginatedTemplateListFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'count': json['count'],
        'next': json['next'],
        'previous': json['previous'],
        'results': (json['results'].map(template_1.TemplateFromJSON)),
    };
}
function PaginatedTemplateListToJSON(json) {
    return PaginatedTemplateListToJSONTyped(json, false);
}
function PaginatedTemplateListToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'count': value['count'],
        'next': value['next'],
        'previous': value['previous'],
        'results': (value['results'].map(template_1.TemplateToJSON)),
    };
}
//# sourceMappingURL=paginatedTemplateList.js.map